var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psCalendar view"},[_c('ps-page-container',{attrs:{"site":{ site: 'Calendario' }}}),(_vm.newEventDialogVisible == true)?_c('ps-calendar-dialog-new-event'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }